module.exports = __webpack_public_path__ + "static/media/connection4.12e11622.svg";